import { Component, OnInit, ViewChild } from '@angular/core';
import { NavController, ModalController } from '@ionic/angular';
import { APIService } from 'src/app/API.service';
import { Router } from '@angular/router';
import { EditUserPage } from '../../edit-user/edit-user.page';
import { SessionService } from '../../services/session.service';
import { DataStore } from '@aws-amplify/datastore';
import { User } from '../../../models';
import { UsersComponent } from '../../components/lists/users/users.component';
import { PaymentsComponent } from '../../components/lists/payments/payments.component';

@Component({
  selector: 'app-payments',
  templateUrl: './payments.page.html',
  styleUrls: ['./payments.page.scss'],
})
export class PaymentsPage implements OnInit {

  @ViewChild('paymentsList') paymentsList: PaymentsComponent;
  cssClass: string;
  showFilters = false;
  filters = {
    name : '',
    status : 'Tutti',
  }


  constructor(
    public navController: NavController, 
    public apiService: APIService,
    public sessionService: SessionService,
    public router: Router,
    public modalController: ModalController,
    ) {
  }

  ngOnInit() {
  }

  filterPayments() {
    this.paymentsList.filterPayments(this.filters);
  }

  ionViewDidEnter() {
    this.refreshUserList();

    // make sure the newly styled content scrolls when needed
    document.querySelectorAll('.main-content')[document.querySelectorAll('.main-content').length-1].shadowRoot.querySelector('.inner-scroll').setAttribute('style', 'height:100%');
  }
  
  private async refreshUserList() {
    // this.paymentsList = await DataStore.query(User);
    // this.applyClassBySelection('rollIn');
  }

  openPage(page: string) {
    return this.router.navigate([page]);
  }  

  back() {
    this.navController.back();
  }


}
